import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase";

const ADMIN_EMAIL = "sproutadmin@gmail.com"; 

export default function ProtectedAdmin({ children }) {
  const [user, loading] = useAuthState(auth);

  if (loading) return <p>Loading...</p>;

  if (!user) {
    return <Navigate to="/admin" />;
  }

  if (user.email !== ADMIN_EMAIL) {
    return <p style={{ padding: "50px" }}>Access Denied</p>;
  }

  return children;
}
